export default __webpack_public_path__ + "static/media/T&C.191199f1.pdf";